<template>
  <el-dialog
    title="合并订单"
    :visible.sync="visible"
    width="950px"
    center
    :close-on-click-modal='false'
    :close-on-press-escape='false'
    :show-close='false'
  >
    <div v-if="showdetail" style="min-height:50px;">
      <div class="new-sort-style orderInfo" v-if="preMergeList && preMergeList.length>0" style="padding-left: 10px">
        <div>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <i class="el-icon-info"></i>
          <span>{{preMergeList[0].receiveName|| ''}}</span>
          <span class="y-ml-40">{{preMergeList[0].receiveMobile|| ''}}</span>
          <span class="y-ml-40">共有</span><span style="font-weight:600"> {{preMergeList.length}} </span><span>笔订单可以手动合并，请选择合并的订单</span>
        </div>
          <el-select :popper-append-to-body="false" class="new-sort-style-select y-w-150" 
          placeholder="请选择" v-model="orderByType" style="width:155px;"
          @change="handleOrderByTypeChange"
          >
            <template v-for="(item, index) in orderTypeList">
              <el-tooltip placement="left" 
              :key="index" effect="light" 
              popper-class="select-option-tooltip-style"
              v-if="curComponent == 'APPLY_ORDER' && (item.value=='createTimeDesc'||item.value=='createTimeAsc'
              ||item.value=='payTimeDesc'||item.value=='payTimeAsc'||item.value=='expShipTimeDesc'||item.value=='expShipTimeAsc')">
                <div slot="content">
                  <div class="tip-title">{{item.name}}</div>
                  <div class="tip-title-sub">规则</div>
                  <div>{{item.rule}}</div>
                  <div class="tip-title-sub">示例</div>
                  <div>{{item.demo}}</div>
                  <div class="tip-title-sub">适用场景</div>
                  <div>{{item.scenarios}}</div>
                </div>
                <el-option :key="index" :label="item.name" :value="item.value"></el-option>
              </el-tooltip>
            </template>
          </el-select>        
      </div>
      <el-checkbox-group class="mergeStyle" v-model="typeList" v-if="preMergeList && preMergeList.length>0">
        <div v-for="(item,index) in preMergeList" :key="index">
          <div class="moreOrder" v-if="item.mergeOrderDetail && item.mergeOrderDetail.length>0">
            <el-checkbox :label="item" class="checkItem">
              <template>
                <div class="totalOrder">合：{{item.mergeOrderDetail.length}}</div>
              </template>
            </el-checkbox>
            <div v-for="(items,index) in item.mergeOrderDetail" :key="index">
              <div class="orderDetailtitle">
                <span class="orderDetailNum">订单{{index+1}}</span>
                <span  class="last3-span">订单号：{{items.orderId}}</span>
                <el-tooltip class="detailinfo" effect="light" :content="items.receiveName|| ''+' '+items.receiveMobile || ''+' '+items.receiveProvince|| ''+items.receiveCity|| ''+items.receiveDistrict || ''+items.receiveAddress|| ''">
                  <span class="last2-span y-ml-60">{{items.receiveName|| ''}} {{items.receiveMobile|| ''}} {{items.receiveProvince|| ''}}{{items.receiveCity|| ''}}{{items.receiveDistrict|| ''}}{{items.receiveAddress|| ''}}</span>
                </el-tooltip>
                <!--下单时间-->
                <span class="last1-span" v-if="orderByType=='createTimeDesc'||orderByType=='createTimeAsc'">{{items.createTime}}</span>
                <!--付款时间-->
                <span class="last1-span" v-if="orderByType=='payTimeDesc'||orderByType=='payTimeAsc'">{{items.payTime}}</span>       
                <!--承诺发货时间-->
                <span class="last1-span" v-if="orderByType=='expShipTimeDesc'||orderByType=='expShipTimeAsc'">{{items.lastShipTime}}</span>                 
              </div>
              <div v-if="items.orderProducts">
                <div class="orderDetail" v-for="(orderitem,index) in items.orderProducts" :key="index">
                  <el-image class="orderImg" :src="orderitem.thumbImg"></el-image>
                  <div class="orderDetailInfo">
                    <div>{{orderitem.productName}}</div>
                    <span class="y-mt-10" v-if="orderitem.skuAttrs && JSON.parse(orderitem.skuAttrs).length >0">
                      <span v-for="(specItem,index) in JSON.parse(orderitem.skuAttrs)" :key="index">{{specItem.attr_value}}{{(index + 1)===JSON.parse(orderitem.skuAttrs).length ? '' : ' / ' }}</span>
                    </span>
                    <span class="y-mt-10">* {{orderitem.skuCnt}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="aloneOrder" v-else>
            <el-checkbox :label="item" class="checkItem">
              <div class="checkItemInfo">
                <span>订单号：{{item.orderId}}</span>
                <el-tooltip class="receiveinfo" effect="light" :content="item.receiveName|| ''+' '+item.receiveMobile|| ''+' '+item.receiveProvince|| ''+item.receiveCity|| ''+item.receiveDistrict || ''+item.receiveAddress|| ''">
                  <span class="last2-span-2 y-ml-60">{{item.receiveName|| ''}} {{item.receiveMobile|| ''}} {{item.receiveProvince|| ''}}{{item.receiveCity|| ''}}{{item.receiveDistrict|| ''}}{{item.receiveAddress|| ''}}</span>
                </el-tooltip>
                <!--下单时间-->
                <span class="last1-span-1" v-if="orderByType=='createTimeDesc'||orderByType=='createTimeAsc'">{{item.createTime}}</span>
                <!--付款时间-->
                <span class="last1-span-1" v-if="orderByType=='payTimeDesc'||orderByType=='payTimeAsc'">{{item.payTime}}</span>       
                <!--承诺发货时间-->
                <span class="last1-span-1" v-if="orderByType=='expShipTimeDesc'||orderByType=='expShipTimeAsc'">{{item.lastShipTime}}</span>                 
              </div>
            </el-checkbox>
            <div v-if="item.orderProducts">
              <div class="orderDetail" v-for="(items,index) in item.orderProducts" :key="index">
                <el-image class="orderImg" :src="items.thumbImg"></el-image>
                <div class="orderDetailInfo">
                  <div>{{items.productName}}</div>
                  <span class="y-mt-10" v-if="items.skuAttrs && JSON.parse(items.skuAttrs).length >0">
                    <span v-for="(specItem,index) in JSON.parse(items.skuAttrs)" :key="index">{{specItem.attr_value}}{{(index + 1)===JSON.parse(items.skuAttrs).length ? '' : ' / ' }}</span>
                  </span>
                  <span class="y-mt-10">* {{items.skuCnt}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-checkbox-group>
    </div>
    <div v-else>
      <div class="orderInfo">
        <i class="el-icon-info"></i>
        请选择合并后的地址
      </div>
      <el-radio-group v-model="radio" class="mergeStyle">
        <el-radio :label="i" class="checkItem" v-for="(i,index) in typeList" :key="index">
          {{preMergeList[index].receiveName|| ''}} {{preMergeList[index].receiveMobile|| ''}} {{preMergeList[index].receiveProvince|| ''}}{{preMergeList[index].receiveCity|| ''}}{{preMergeList[index].receiveDistrict|| ''}}{{preMergeList[index].receiveAddress|| ''}}
        </el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="showdetail = true" v-if='!showdetail'>上一步</el-button>
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="toNext" v-if='showdetail'>下一步</el-button>
      <el-button type="primary" @click="toMerge" v-if='!showdetail'>确认合并</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['preMergeList', 'checkedOrderIdList','curComponent','orderTypeList'],
  data() {
    return {
      orderByType:'createTimeAsc',
      visible: true,
      typeList: [],
      showdetail: false,
      radio: '',
      checkAll: false,
      isIndeterminate: false, // 表示checkbox的不确定状态
    };
  },
  methods: {
    handleOrderByTypeChange(val){
      this.$emit("handleOrderByTypeChange",val);
      console.log('handleOrderByTypeChange',val);
    },    
    toMerge() {
      if (!this.radio) {
        this.$message.warning('请选择合并订单地址');
        return false;
      }
      let orderIds = [];
      if (this.typeList && this.typeList.length > 0) {
        this.typeList.forEach(function (r) {
          if (r.mergeOrderIds) {
            let mergeOrderIds = JSON.parse(r.mergeOrderIds);
            orderIds = [...orderIds, ...mergeOrderIds];
          } else {
            orderIds.push(r.orderId);
          }
        });
      }
      this.$emit('handleMergeOrder', orderIds)
    },
    handleCheckAllChange(val) {
      // 处理全选的逻辑
      this.typeList = val ? this.preMergeList : [];
      this.isIndeterminate = false;
    },
    toNext() {
      if (this.typeList && this.typeList.length > 1) {
        this.showdetail = false;
        this.radio = this.typeList[0];
      } else {
        this.$message.warning('请至少选择两笔订单进行合并');
      }
    },
  },
  mounted() {
    this.showdetail = true;
    this.typeList = [];
    let orderIdList = [];
    this.preMergeList.forEach(r => {
      if (JSON.stringify(this.checkedOrderIdList).indexOf(r.orderId) !== -1) {
        orderIdList.push(r);
      };
    });
    this.typeList = [...orderIdList];
  },
  watch: {
    typeList: {
      handler(val) {
        let checkedCount = val.length;
        this.checkAll = checkedCount === this.preMergeList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.preMergeList.length;
      },
      deep: true,
      immediate: true
    },
    visible(val) {
      this.$emit('update:fromParentVisible', val)
    }
  }
};
</script>
<style lang="scss" scoped>
.mergeStyle{
  max-height: 500px;
  overflow: auto;
}
.orderInfo{
  height:40px;
  background:$tiffany;
  border-radius:4px;
  border:1px solid $tiffany-border;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.65);
  line-height:40px;
  margin-bottom: 10px;
  .el-icon-info{
    color: $blue-style;
    font-size: 14px;
    margin: 0 0 0 10px;
  }
}
.new-sort-style{
  display: flex;
  justify-content: space-between;
  align-items: center;      
}
.new-sort-style-select{
  margin-right: 10px;
}
.aloneOrder{
  margin-bottom: 10px;
  .checkItem{
    width: 100%;
    height:40px;
    line-height: 40px;
    background:rgba(248,248,255,1);
    border-radius:2px 2px 0px 0px;
    margin-right: 0;
    font-size: 14px;
    margin-bottom: 1px;
    padding: 0 10px;
    box-sizing: border-box;
    .checkItemInfo{
      font-size:12px;
      font-family:MicrosoftYaHei;
      color:rgba(102,102,102,1);
      line-height:14px;
      
      .receiveinfo{
        display: inline-block;
        width: 590px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .last2-span-2{
          display: inline-block;
          overflow: hidden;
          width: 450px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
      }
      .last1-span-1{
          display: inline-block;
          overflow: hidden;
          width: 150px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
      }       
    }
  }
  .orderDetail{
    width:100%;
    background:rgba(248,248,255,1);
    border-radius:2px 2px 0px 0px;
    font-size: 12px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .orderImg{
      width:80px;
      height:55px;
      margin-right: 20px;
    }
    .orderDetailInfo{
      font-size:12px;
      font-family:MicrosoftYaHei;
      color:rgba(51,51,51,1);
      line-height:19px;
    }
  }
}
.moreOrder{
  margin-bottom: 10px;
  .checkItem{
    width: 100%;
    height:40px;
    line-height: 40px;
    background:rgba(248,248,255,1);
    border-radius:2px 2px 0px 0px;
    margin-right: 0;
    font-size: 14px;
    margin-bottom: 1px;
    padding: 0 10px;
    box-sizing: border-box;
    .totalOrder{
      width:50px;
      height:18px;
      background:rgba(230,167,51,1);
      border-radius:3px;
      border:1px solid rgba(230,167,51,1);
      text-align: center;
      font-size:11px;
      font-family:MicrosoftYaHei;
      color:rgba(255,255,255,1);
      line-height:18px;
    }
  }
  .orderDetailtitle{
    width:100%;
    background:rgba(248,248,255,1);
    border-radius:2px 2px 0px 0px;
    font-size: 12px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 1px;
    span{
      flex-shrink: 0;
    }
    .last3-span{
      display: inline-block;
      overflow: hidden;
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .last2-span{
      display: inline-block;
      overflow: hidden;
      width: 450px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .last1-span{
      display: inline-block;
      overflow: hidden;
      width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }    
    .detailinfo{
      display: inline-block;
      overflow: hidden;
      width: 530px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .orderDetailNum{
      height:14px;
      font-size:12px;
      font-family:MicrosoftYaHei;
      color:$blue-style;
      line-height:14px;
      margin: 0 30px 0 20px;
    }
  }
  .orderDetail{
    width:100%;
    background:rgba(248,248,255,1);
    border-radius:2px 2px 0px 0px;
    font-size: 12px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 5px;
    .orderImg{
      width:80px;
      height:55px;
      margin-right: 20px;
    }
    .orderDetailInfo{
      font-size:12px;
      font-family:MicrosoftYaHei;
      color:rgba(51,51,51,1);
      line-height:19px;
    }
  }
}
.checkItem{
  width: 100%;
  height:40px;
  line-height: 40px;
  background:rgba(248,248,255,1);
  border-radius:2px 2px 0px 0px;
  margin-right: 0;
  font-size: 14px;
  margin-bottom: 1px;
  padding: 0 10px;
  box-sizing: border-box;
  .checkItemInfo{
    font-size:14px;
    font-family:MicrosoftYaHei;
    color:rgba(102,102,102,1);
    line-height:14px;
  }
}
</style>
